import { useContext, useState } from 'react'
import { FiGrid } from 'react-icons/fi'
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi'
import { useMediaQuery } from 'react-responsive'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useSwipeable } from 'react-swipeable'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { ModalTotalContext } from '../../../context/ModalContext'
import logo from '../../../icons/logo-RGB-36.png'
import logoTiny from '../../../icons/logo-RGB-39.png'
import { breakpoints } from '../../../MediasQueries'
import { MenuData } from './MenuData'
import {
  Arrow,
  Button,
  ContainerItems,
  ContainerLogo,
  ContainerMenu,
  ContentItem,
  MenuItem,
  MenuMobile,
} from './style'
import SubMenu from './SubMenu'

const Menu = ({ openMenu, setOpenMenu }) => {
  const { signOut } = useContext(AuthContext)
  const { openModal, setOpenModal } = useContext(ModalTotalContext)
  const [isHover, setIsHover] = useState(false)
  const { pathname } = useLocation()
  const isDesktop = useMediaQuery({ minWidth: breakpoints.lg })
  // const navigate = useNavigate()

  // const handle = (val) => {
  //   val.title === 'Sair' ? signOut() : navigate(val.link)

  //   setOpenModal(null)
  // }
  const swipeOpenMenuStyles = (direction) => {
    return {
      right: direction === 'right' ? 0 : null,
      position: 'fixed',
      width: '5%',
      height: '100%',
      'z-index': '7',
    }
  }
  const handlers = useSwipeable({
    onSwipedRight: () => setOpenModal('Menu'),
    delta: 1,
  })
  const handlersOver = useSwipeable({
    onSwipedLeft: () => setOpenModal(),
    delta: 1,
  })
  return (
    <>
      {!isDesktop && (
        <>
          <div style={swipeOpenMenuStyles('left')} {...handlers}></div>
          <div style={swipeOpenMenuStyles('right')} {...handlersOver}></div>
        </>
      )}
      {isDesktop && (
        <ContainerMenu
          openMenu={openMenu}
          isHover={isHover}
          onMouseOver={() => setIsHover(true)}
          onMouseOut={() => setIsHover(false)}
        >
          <ContainerLogo enabled={isHover || openMenu}>
            <img src={logo} alt="logo" className="logo" />
            <img src={logoTiny} alt="logo" className="logoTiny" />
            {(openMenu || isHover) && (
              <Button onClick={openMenu ? () => setOpenMenu(false) : () => setOpenMenu(true)}>
                <FiGrid />
              </Button>
            )}
          </ContainerLogo>
          <ContainerItems openMenu={openMenu} isHover={isHover}>
            <ul>
              {MenuData?.map((val) => {
                const [subNav, setSubNav] = useState(false)
                return (
                  <MenuItem key={val.title}>
                    <Link to={val.link}>
                      <ContentItem
                        openMenu={openMenu}
                        isHover={isHover}
                        active={val.link === pathname}
                        onClick={val.title === 'Sair' ? signOut : () => setSubNav(!subNav)}
                      >
                        <div>
                          {val.icon}
                          {(openMenu || isHover) && <span className="title">{val.title}</span>}
                        </div>

                        {(openMenu || isHover) && (
                          <Arrow>
                            {val.subitems ? (
                              subNav ? (
                                <HiOutlineChevronUp />
                              ) : (
                                <HiOutlineChevronDown />
                              )
                            ) : null}
                          </Arrow>
                        )}
                      </ContentItem>

                      {subNav &&
                        val.subitems &&
                        (isHover || openMenu) &&
                        val.subitems.map((v) => {
                          return <SubMenu key={v.title} value={v} pathname={pathname} />
                        })}
                    </Link>
                  </MenuItem>
                )
              })}
            </ul>
          </ContainerItems>
        </ContainerMenu>
      )}
      {!isDesktop && (
        <MenuMobile active={openModal === 'Menu' ? true : false}>
          <ul>
            {MenuData?.map((val) => {
              const [subNav, setSubNav] = useState(false)
              return (
                <MenuItem key={val.title}>
                  <Link to={val.link} onClick={() => (val.subitems ? null : setOpenModal(null))}>
                    <ContentItem
                      openMenu={openMenu}
                      isHover={isHover}
                      active={val.link === pathname}
                      onClick={val.title === 'Sair' ? signOut : () => setSubNav(!subNav)}
                    >
                      <div>
                        {val.icon}
                        {(openMenu || isHover) && <span className="title">{val.title}</span>}
                      </div>

                      {(openMenu || isHover) && (
                        <Arrow>
                          {val.subitems ? (
                            subNav ? (
                              <HiOutlineChevronUp />
                            ) : (
                              <HiOutlineChevronDown />
                            )
                          ) : null}
                        </Arrow>
                      )}
                    </ContentItem>

                    {subNav &&
                      val.subitems &&
                      (isHover || openMenu) &&
                      val.subitems.map((v) => {
                        return <SubMenu key={v.title} value={v} pathname={pathname} />
                      })}
                  </Link>
                </MenuItem>
              )
            })}
          </ul>
        </MenuMobile>
      )}

      <Outlet />
    </>
  )
}
export default Menu
